@if (overrideCssUrl) {
  <link rel="stylesheet" type="text/css" [href]="overrideCssUrl | safeUrl">
}

@if (!isLoading) {
  <router-outlet></router-outlet>
}
@if (globalSpinnerVisible$ | async) {
  <div class="global-spinner-overlay">
    <loading-indicator
      loadingMessage="Please wait..."
      [includeCardClass]="false"
      [useTransparentBg]="true"
      dotsColor="#fff"
    ></loading-indicator>
  </div>
}
@if (isLoading) {
  <loading-indicator
    [customClass]="'init-loading-indicator'"
    [includeCardClass]="false"
    [customHeight]="'100vh'">
  </loading-indicator>
}

<session-timeout></session-timeout>
